export default __webpack_public_path__ + "static/media/koda-app.1fb3ac57.png";